import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { KEYS_ARROW_UP, KEYS_ARROW_DOWN } from '../../constants/keyboardKeys'
import { isChecklistItemIdNew } from '../../util/checklistHelper'
import ChecklistItemRow from './ChecklistItemRow'
import includes from 'lodash/includes'
import { SortableContainer } from 'react-sortable-hoc'

const createNavigationHandler = (index) => {
  const handledKeys = [KEYS_ARROW_UP, KEYS_ARROW_DOWN]

  return (event, targetSelector) => {
    const { key } = event

    if (!includes(handledKeys, key)) {
      return
    }

    event.stopPropagation()
    event.preventDefault()

    const elements = document.querySelectorAll(targetSelector)

    if (event.key === KEYS_ARROW_UP && index > 0) {
      elements[index - 1].focus()
    }

    if (event.key === KEYS_ARROW_DOWN && index < (elements.length - 1)) {
      elements[index + 1].focus()
    }
  }
}

/**
 * @augments{ PureComponent<any, any> }
 */
class Checklist extends PureComponent {
  render() {
    const { createTaskChecklistItem, deleteTaskChecklistItem, items, saveTaskChecklistItem } = this.props
    return (
      <div>
        { items.map((value, index) => (
          <ChecklistItemRow
            key={value.id}
            index={index}
            rowIndex={index} // Can't reuse index as that is stripped by react-sortable-hoc
            checklistItem={value}
            navigationHandler={createNavigationHandler}
            createTaskChecklistItem={createTaskChecklistItem}
            saveTaskChecklistItem={saveTaskChecklistItem}
            deleteTaskChecklistItem={deleteTaskChecklistItem}
            isAdding={isChecklistItemIdNew(value.id)} />
        ))}
      </div>
    )
  }
}

Checklist.propTypes = {
  items: PropTypes.array,
  createTaskChecklistItem: PropTypes.func.isRequired,
  saveTaskChecklistItem: PropTypes.func.isRequired,
  deleteTaskChecklistItem: PropTypes.func.isRequired
}

export default SortableContainer(Checklist, { withRef: true })



// WEBPACK FOOTER //
// ./src/components/ChecklistPanel/Checklist.js